<!-- 上期统计组件 -->
<template>
    <div class="stat-card">
        <!-- 头部标题 -->
        <!-- <div class="stat-header">
            <span class="stat-header-icon">📊</span>
            <span class="stat-header-title">上期统计</span>
            <span class="stat-header-badge">实时</span>
        </div> -->

        <!-- 统计数据行 -->
        <van-row class="stat-row" gutter="0">
            <van-col span="6" class="stat-item">
                <div class="" style="font-size: 30px; line-height: 20px;">📊</div>
                <div class="" style="font-size: 12px; font-weight: bold; line-height: 30px;">上期统计</div>
            </van-col>
            <!-- 中直选 -->
            <van-col span="6" class="stat-item">
                <div class="stat-item-label">中直选</div>
                <div class="stat-item-value text-danger">{{ zhixuanCount }}<small>人</small></div>
            </van-col>
            <!-- 中组3 -->
            <van-col span="6" class="stat-item">
                <div class="stat-item-label">中组3</div>
                <div class="stat-item-value text-muted">{{ z3Count }}<small>人</small></div>
            </van-col>
            <!-- 中组6 -->
            <van-col span="6" class="stat-item">
                <div class="stat-item-label">中组6</div>
                <div class="stat-item-value text-danger">{{ z6Count }}<small>人</small></div>
            </van-col>
        </van-row>

        <!-- 底部提示（可选） -->
        <div class="stat-footer">
            <van-icon name="info-o" size="14" />
            <span>数据更新于 {{ currentTime }}</span>
        </div>
    </div>
</template>

<script>
import dayjs from 'dayjs';
export default {
    name: 'UpIssueSum',
    props: ['z3Count', 'z6Count', 'zhixuanCount'],
    data() {
        return {
            currentTime: dayjs().format('YYYY-MM-DD HH:00:00'),
        };
    },
}
</script>

<style scoped>
.stat-card {
    background: #ffffff;
    border-radius: 8px;
    padding: 16px 16px 12px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
    margin-bottom: 6px;
    margin-top: 16px;
}

.stat-header {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 14px;
}

.stat-header-icon {
    font-size: 18px;
}

.stat-header-title {
    font-size: 15px;
    font-weight: 600;
    color: #323233;
}

.stat-header-badge {
    font-size: 10px;
    background: #ee0a24;
    color: #fff;
    padding: 0 8px;
    border-radius: 10px;
    line-height: 18px;
    margin-left: auto;
}

.stat-row {
    text-align: center;
}

.stat-item {
    padding: 4px 0;
}

.stat-item-label {
    font-size: 14px;
    color: #969799;
    margin-bottom: 4px;
}

.stat-item-value {
    font-size: 22px;
    font-weight: 600;
    line-height: 1.2;
}

.stat-item-value small {
    font-size: 12px;
    font-weight: 400;
    margin-left: 2px;
    color: #969799;
}

.text-danger {
    color: #ee0a24;
}

.text-muted {
    color: #969799;
}

.stat-footer {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    margin-top: 0px;
    padding-top: 10px;
    border-top: 1px solid #f7f8fa;
    font-size: 12px;
    color: #969799;
}
</style>